import axios from 'axios'
import {
  DeviceSchema,
  TrackDeviceSchema,
  BoatStopsResponseSchema,
} from '../models/devices'
import { z } from 'zod'
import { useQuery } from '@tanstack/react-query'

const getDevices = async () => {
  try {
    const res = await axios.get('/api/devices')
    return z.array(DeviceSchema).parse(res.data)
  } catch (error) {
    throw new Error('Failed to get devices.')
  }
}

export const useDevices = () => {
  return useQuery({
    queryKey: ['devices'],
    queryFn: () => getDevices(),
  })
}

const getTrackDeviceInfo = async (
  deviceImei: string,
  start: string,
  end: string
) => {
  try {
    const res = await axios.get(
      `/api/track?device=${deviceImei}&start=${start}&end=${end}`
    )
    return TrackDeviceSchema.parse(res.data)
  } catch (error) {
    throw new Error('Failed to get device info.')
  }
}

export const useTrackDeviceInfo = (
  deviceImei: string,
  start: Date,
  end: Date
) => {
  let startStr = start.toISOString().split('T')[0]
  let endStr = end.toISOString().split('T')[0]
  return useQuery({
    queryKey: ['device', deviceImei, startStr, endStr],
    queryFn: () => getTrackDeviceInfo(deviceImei, startStr, endStr),
  })
}

const getBoatStops = async (deviceImei: string, start: string, end: string) => {
  try {
    console.log('Fetching boat stops for:', deviceImei, start, end)
    const res = await axios.get(
      `/api/geo/admin_boat_stops?device_imei=${deviceImei}&start=${start}&end=${end}`
    )
    console.log('Boat stops response:', res.data)
    return BoatStopsResponseSchema.parse(res.data)
  } catch (error) {
    console.error('Error fetching boat stops:', error)
    if (axios.isAxiosError(error)) {
      console.error('Response data:', error.response?.data)
      console.error('Response status:', error.response?.status)
    }
    throw new Error('Failed to get boat stops.')
  }
}

export const useBoatStops = (deviceImei: string, start: Date, end: Date) => {
  let startStr = start.toISOString().split('T')[0]
  let endStr = end.toISOString().split('T')[0]
  return useQuery({
    queryKey: ['boatStops', deviceImei, startStr, endStr],
    queryFn: () => getBoatStops(deviceImei, startStr, endStr),
  })
}
